/**
 * Okuma ekranları sözleşmesi — VERİ DURUMU kodları ve alanlar.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * "ÇEVRİMDIŞI" TEK BİR ŞEY DEĞİLDİR — ve ayrımı kaybetmek pahalıdır.
 *
 * Eski sistemde saha ya "var" ya "yok"tu; 29 sahanın 7 gündür sessiz olduğu
 * fark edilmedi çünkü hiçbir ekran farkı göstermiyordu. Yeni sistemde altı
 * ayrı hâl var ve üçü BİRBİRİNE HİÇ BENZEMİYOR:
 *
 *   · hiç denenmedi        → yeni kurulmuş, toplayıcı henüz uğramadı
 *   · hiç başarılı olmadı  → deneniyor ama BİR KEZ BİLE okunamadı
 *                            (adres yanlış? cihaz kapalı? — kurulum hatası)
 *   · ulaşılamıyor         → önceden okunuyordu, ŞİMDİ okunamıyor
 *                            (hat, elektrik, VPN — saha tarafı)
 *
 * İkincisi ile üçüncüsü aynı rozetle gösterilseydi, yanlış girilmiş bir IP
 * ile gerçek bir saha arızası aynı görünürdü. Eski sistemdeki `0.0.0.0`
 * panosu tam olarak ikinci gruptaydı ve yedi gün "çevrimdışı" sanıldı.
 * ═══════════════════════════════════════════════════════════════════════════
 */
/** Veri durumu kodları — sunucu hesaplar, arayüz çevirir. */
export const VERI_DURUMLARI = [
    /** Veri akıyor: son başarılı okuma tolerans içinde. */
    'flowing',
    /** Gecikmiş: son başarılı okuma var ama beklenenden ESKİ. */
    'late',
    /** Ulaşılamıyor: son deneme başarısız (önceden okunmuştu). */
    'unreachable',
    /** Deneniyor ama HİÇ başarılı okuma olmamış — kurulum hatası işareti. */
    'never_ok',
    /** Henüz hiç denenmemiş — toplayıcı bu panoya uğramadı. */
    'never_polled',
    /** Veri BEKLENMİYOR: yoklama kapalı ya da pano yok. Alarm değil. */
    'not_expected',
];
/**
 * Bir sahanın durumu, panolarının EN KÖTÜSÜDÜR.
 *
 * İki panolu bir sahada biri okunuyor diğeri okunamıyorsa saha "veri akıyor"
 * gösterilemez — okunamayan panonun tankları da o sahada. Sıralama sayısı
 * büyüdükçe kötüleşir; `not_expected` en altta çünkü o bir arıza değil bir
 * yapılandırma tercihi.
 */
export const VERI_DURUMU_SIRASI = {
    not_expected: 0,
    flowing: 1,
    late: 2,
    never_polled: 3,
    never_ok: 4,
    unreachable: 5,
};
/**
 * TOLERANS: kaç kat gecikme "gecikmiş" sayılır?
 *
 * Tek bir kaçırılmış poll çevrimdışılık değildir — ağ bir kez takılmış
 * olabilir. İki poll aralığı + 60 sn kayma payı: 5 dakikada bir okunan pano
 * için ~11 dakika, saatte bir okunan için ~2 saat. SABİT bir eşik (örn.
 * "15 dakika") saatlik yoklanan panoyu sürekli kırmızı gösterirdi.
 */
export const GECIKME_KAT_SAYISI = 2;
export const GECIKME_PAYI_SN = 60;
/** `GET /readings/sites` satırı. */
export const OKUMA_SAHA_ALANLARI = [
    'site_id',
    'name',
    'addr_code',
    'city',
    'panel_count',
    'polling_count',
    'data_state',
    'last_ok_at',
    'last_attempt_at',
    'last_outcome',
    'consecutive_failures',
    'poll_interval_seconds',
    'tank_count',
    'tanks',
];
/** Satır içindeki tank özeti. */
export const OKUMA_TANK_ALANLARI = [
    'tank_id',
    'tank_number',
    'serial_number',
    'capacity_m3',
    'nominal_kg',
    'level_pct',
    'pressure_bar',
    'read_at',
];
/**
 * BOOL sinyal türleri — `measurement_kind` enum'ının bool kısmıyla BİREBİR.
 *
 * ⚠️ Bu liste UYDURULMAZ, şemadan kopyalanır. Bu projede aynı sınıf hata iki
 * kez yakalandı (olmayan bir `tank_orientation` değeri, olmayan bir `tank_view`
 * izni) ve ikisi de ancak çalıştırınca görüldü. `readings-test` listeyi
 * veritabanının `pg_enum`'ıyla karşılaştırıyor: sapma testi kırar.
 */
export const BOOL_SINYAL_TURLERI = [
    'siren',
    'solenoid',
    'emergency_stop',
    'heater_on',
    'low_temperature',
    'earthquake',
    'site_ac',
    'gas_detector',
];
/**
 * Doluluk oranından kg — PROJECT.md §hesaplama kuralları.
 *
 * `level` yüzdedir ve 0–100'e KIRPILIR: PLC bozuk okumada 105 verirse tank
 * nominalinden fazla göstermemeli. Eski sistemin formülünün aynısı, tek fark
 * biçimde: kg her yerde TAMSAYI (eski sistemde listede tamsayı, açılır
 * pencerede bir ondalıklıydı — aynı tank iki ekranda iki değer gösteriyordu).
 */
export function dolulukKg(levelPct, nominalKg) {
    if (levelPct === null || nominalKg === null)
        return null;
    const oran = Math.min(Math.max(levelPct / 100, 0), 1);
    return Math.round(nominalKg * oran);
}
//# sourceMappingURL=readings.js.map